module.exports = __webpack_public_path__ + "img/levelup-logout.82bd9ab4.svg";